import React, { useState } from 'react';
import TabLayout from '../../components/tab-components/TabLayout';
import TabHeader from '../../components/tab-components/TabHeader';
import TabBody from '../../components/tab-components/TabBody';
import TicketTypes from './TicketTypes';
import TicketsList from './tickets/TicketsList';
import { ticketsTabsList } from './utils';

const Tickets = () => {
  const [selectedTab, setSelectedTab] = useState(ticketsTabsList[0]);
  return (
    <>
      <TabLayout>
        <TabHeader
          tabList={ticketsTabsList}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
        <TabBody>
          <div className='p-3'>
            {selectedTab.value === 'tickets_types' ? <TicketTypes /> : <TicketsList />}
          </div>
        </TabBody>
      </TabLayout>
    </>
  );
};

export default Tickets;
